async function getBankHolidays() {
  const cacheKey = 'ukBankHolidays';
  const cachedRaw = sessionStorage.getItem(cacheKey);
  if (cachedRaw) {
    const cached = JSON.parse(cachedRaw);
    if (Date.now() - cached.fetchedAt < 24 * 60 * 60 * 1000) {
      return cached.dates;
    }
  }
  const res = await fetch('https://www.gov.uk/bank-holidays.json');
  const data = await res.json();
  const dates = data['england-and-wales'].events.map(e => e.date);
  sessionStorage.setItem(cacheKey, JSON.stringify({ dates, fetchedAt: Date.now() }));
  return dates;
}

function getUKNow() {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  }).formatToParts(new Date());
  const map = {};
  parts.forEach(p => map[p.type] = p.value);
  return new Date(`${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`);
}

function isWorkingDay(date, holidays) {
  const day = date.getDay();
  const iso = date.toISOString().split('T')[0];
  return day !== 0 && day !== 6 && !holidays.includes(iso);
}

function addWorkingDays(startDate, daysToAdd, holidays) {
  const result = new Date(startDate);
  let added = 0;
  while (added < daysToAdd) {
    result.setDate(result.getDate() + 1);
    if (isWorkingDay(result, holidays)) added++;
  }
  return result;
}

function getCutoffTime(el) {
  const hour = parseInt(el.dataset.cutoffHour, 10);
  const minute = parseInt(el.dataset.cutoffMinute, 10);
  return {
    hour: Number.isFinite(hour) ? hour : 14,
    minute: Number.isFinite(minute) ? minute : 0
  };
}

async function calculateDispatchAndDelivery(leadTimeDays, el) {
  const holidays = await getBankHolidays();
  const now = getUKNow();
  const { hour, minute } = getCutoffTime(el);

  const cutoffToday = new Date(now);
  cutoffToday.setHours(hour, minute, 0, 0);
  const pastCutoff = now >= cutoffToday;

  let dispatchDate;
  if (leadTimeDays > 0) {
    dispatchDate = addWorkingDays(now, leadTimeDays, holidays);
  } else {
    dispatchDate = pastCutoff ? addWorkingDays(now, 1, holidays) : new Date(now);
    if (!isWorkingDay(dispatchDate, holidays)) {
      dispatchDate = addWorkingDays(dispatchDate, 1, holidays);
    }
  }

  const deliveryDate = leadTimeDays > 0 ? null : addWorkingDays(dispatchDate, 1, holidays);
  return { dispatchDate, deliveryDate };
}

function formatUKDate(date) {
  const formatted = new Intl.DateTimeFormat('en-GB', {
    weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London'
  }).format(date);
  return formatted.replace(/(\d+)/, d => {
    const n = parseInt(d, 10);
    const suffix = (n % 10 === 1 && n !== 11) ? 'st'
      : (n % 10 === 2 && n !== 12) ? 'nd'
      : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    return `${n}${suffix}`;
  });
}

function startCountdown(el, countdownEl) {
  function tick() {
    const now = getUKNow();
    const { hour, minute } = getCutoffTime(el);
    const cutoff = new Date(now);
    cutoff.setHours(hour, minute, 0, 0);
    const diff = cutoff - now;
    if (diff < 0) {
      countdownEl.textContent = 'Order now';
      return;
    }
    const hrs = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    countdownEl.textContent = `${hrs}hrs ${mins}m`;
  }
  tick();
  setInterval(tick, 60000);
}

function initDeliveryEstimates() {
  document.querySelectorAll('[data-delivery-estimate]').forEach(async (el) => {
    const leadTime = parseInt(el.dataset.leadTime || '0', 10);
    const { dispatchDate, deliveryDate } = await calculateDispatchAndDelivery(leadTime, el);

    const countdownEl = el.querySelector('[data-countdown]');
    if (countdownEl) startCountdown(el, countdownEl);

    const dateEl = el.querySelector('[data-date]');
    if (dateEl) {
      dateEl.textContent = deliveryDate ? formatUKDate(deliveryDate) : formatUKDate(dispatchDate);
    }
  });
}

document.addEventListener('DOMContentLoaded', initDeliveryEstimates);